import { Popconfirm } from 'antd'
import { PopconfirmProps } from 'antd/lib'

import { useLocales } from 'src/locales'

export const SaveConfirm = (props: PopconfirmProps) => {
  const { t } = useLocales()

  return (
    <Popconfirm
      placement="bottom"
      description={t('common.save_description')}
      {...props}
    >
      {props.children}
    </Popconfirm>
  )
}
